import styled from "styled-components";

export default styled.div`
  min-height: 42px;

  @keyframes show {
    from {
      max-height: 0px;
    }

    to {
      max-height: 200px;
    }
  }
`;
